import React, { useState } from "react";
import { GoogleMap, Marker, withGoogleMap } from "react-google-maps";
import marker from "../../../../../images/marker.png";

const Map = (props: any) => {
  const coordenadas = props.coordenadas;
  const setCoordenadas = props.setCoordenadas;
  const [markerAnimation, setMarkerAnimation] = useState(2);

  const onDragEnd = (e: any) => {
    setCoordenadas({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
    setMarkerAnimation(0);
  };

  const onDragStart = (e: any) => {
    setMarkerAnimation(1);
  };

  return (
    <GoogleMap
      center={coordenadas}
      defaultOptions={{
        gestureHandling: "greedy",
        disableDefaultUI: false,
        zoom: 12,
        minZoom: 5,
        maxZoom: 18,
        streetViewControl: false,
        rotateControl: false,
        panControl: false,
        mapTypeControl: false,
      }}
    >
      <Marker
        position={coordenadas}
        draggable={true}
        onDragEnd={onDragEnd}
        onDragStart={onDragStart}
        animation={markerAnimation}
        icon={marker}
      />
    </GoogleMap>
  );
};

export default withGoogleMap(Map);
